module.exports = __webpack_public_path__ + "img/lg_ring_y_0_null_0.c2a8718e.png";